var _desc, _rect, _rect2, _circle, _circle2, _circle3, _g, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "termTitle"
  }, "Terminal typing Hello world") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "termTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "termDesc"
  }, "An animated terminal typing Hello world with a blinking cursor")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 220,
    height: 90,
    rx: 8,
    ry: 8,
    fill: "#0f1724"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 220,
    height: 18,
    rx: 8,
    ry: 8,
    fill: "#0b1220"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 24,
    r: 3,
    fill: "#ff5f56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 24,
    r: 3,
    fill: "#ffbd2e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 24,
    r: 3,
    fill: "#27c93f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26,55)",
    fontFamily: "monospace",
    fontSize: "18px",
    fill: "#e6f0ff"
  }, /*#__PURE__*/React.createElement("text", {
    className: "typed"
  }, "Hello world"), /*#__PURE__*/React.createElement("rect", {
    className: "cursor",
    x: 0,
    y: -14,
    width: 10,
    height: 20,
    fill: "#e6f0ff",
    rx: 2,
    ry: 2
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .typed {\n      overflow: hidden;\n      white-space: nowrap;\n      width: 0ch;\n      animation: typing 3s steps(11, end) infinite 1s;\n    }\n\n    .cursor {\n      animation: blink 1s steps(2, start) infinite, move 3s steps(11, end) infinite 1s;\n    }\n\n    @keyframes typing {\n      0% { width: 0ch; }\n      60% { width: 11ch; } /* 'Hello world' has 11 chars */\n      100% { width: 0ch; }\n    }\n\n    @keyframes blink {\n      0%, 49% { opacity: 1; }\n      50%, 100% { opacity: 0; }\n    }\n\n    @keyframes move {\n      0%   { transform: translateX(0ch); }\n      60%  { transform: translateX(11ch); }\n      100% { transform: translateX(0ch); }\n    }\n\n    /* Reduce motion preference */\n    @media (prefers-reduced-motion: reduce) {\n      .typed { animation: none; width: 11ch; }\n      .cursor { animation: blink 1s steps(2, start) infinite; transform: translateX(11ch); }\n    }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.accfb806b75223b23b1185ebdd5cbb5a.svg";
export { ForwardRef as ReactComponent };